import { useRef, useState } from 'react';

import { useNotification } from '../Contexts/NotificationContext';
import { useToken } from '../Contexts/TokenContext';

const TermsModal = () => {
    const { setNotification } = useNotification();
    const [canAccept, setCanAccept] = useState(false);
    const [sending, setSending] = useState(false);
    const textoContainerRef = useRef(null);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;
    const { forceTokenCheck } = useToken();

    const verificarScroll = () => {
        const container = textoContainerRef.current;
        if (!container) return;

        const estaNoFim = Math.abs(container.scrollHeight - container.scrollTop - container.clientHeight) < 10;

        if (estaNoFim && !canAccept) {
            setCanAccept(true);
        }
    };

    const handleAceitar = async () => {
        if (!canAccept) return;

        try {
            setSending(true);

            const response = await fetch(`${baseUrl}/painel/usuario/termos`, {
                method: 'POST',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'Content-Type': 'application/json',
                },
            });

            if (response.ok) {
                await forceTokenCheck(true);
            } else {
                const errorData = await response.json();

                throw new Error(`Erro ao aceitar os termos: ${errorData.message || 'Erro desconhecido'}`);
            }
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setSending(false);
        }
    };

    return (
        <div className="max-w-3xl mx-auto p-6 bg-white rounded-lg shadow-lg">
            <h1 className="text-2xl font-bold mb-4 text-gray-800">Termos de Uso</h1>

            <div
                ref={textoContainerRef}
                onScroll={verificarScroll}
                className="bg-gray-50 border border-gray-200 rounded-md p-4 mb-6 h-80 overflow-y-auto text-gray-700"
            >
                <h2 className="text-xl font-semibold mb-2">1 - O que precisamos de voc&ecirc;</h2>

                <p>
                    A Intranet Rometal &eacute; um Controlador dos dados pessoais que voc&ecirc; (titular de dados) nos fornece. Coletamos
                    os seguintes tipos de dados pessoais de voc&ecirc;:
                </p>

                <p>Nome</p>

                <p>E-mail</p>

                <p>Telefone</p>

                <p>Empresa</p>

                <p>CNPJ</p>

                <p>&nbsp;</p>

                <h2 className="text-xl font-semibold mb-2">2 - Por que precisamos destes dados?</h2>

                <p>
                    Precisamos de seus dados pessoais para fornecer o contato do Titular com a empresa, atrav&eacute;s do Formul&aacute;rio
                    de Contato presente no site. &Eacute; o canal de contato dos clientes com a empresa, por isso necessitamos dos dados
                    para uma melhor experi&ecirc;ncia para o titular de dados.
                </p>

                <p>&nbsp;</p>

                <h2 className="text-xl font-semibold mb-2">3 - O que fazemos com seus dados</h2>

                <p>
                    Seus dados s&atilde;o tratados internamente para retornar para voc&ecirc; o que foi solicitado no formul&aacute;rio de
                    contato ou para recebimento de informa&ccedil;&otilde;es, novidades, newsletters e conte&uacute;dos promocionais.
                </p>

                <p>
                    A hospedagem e o armazenamento de seus dados ocorrem no site da Rometal, que est&aacute; localizado no Brasil. Os dados
                    ser&atilde;o compartilhados com terceiros para fins publicit&aacute;rios e melhorias de experi&ecirc;ncia: RD Station,
                    Google, Meta, Youtube.&nbsp; Ainda, os seus dados poder&atilde;o ser repassados para Representantes Comerciais, em caso
                    de necessidade de retorno de contato.
                </p>

                <p>&nbsp;</p>

                <h2 className="text-xl font-semibold mb-2">4 - Por quanto tempo n&oacute;s mantemos seus dados pessoais</h2>

                <p>
                    Os seus dados pessoais s&atilde;o mantidos por 5 anos, de acordo com a nossa Pol&iacute;tica de Reten&ccedil;&atilde;o
                    de Dados. Ap&oacute;s esse per&iacute;odo, seus dados pessoais ser&atilde;o irreversivelmente eliminados. Quaisquer
                    dados pessoais para notifica&ccedil;&otilde;es de marketing e atualiza&ccedil;&atilde;o de servi&ccedil;os ser&atilde;o
                    mantidos por n&oacute;s at&eacute; que voc&ecirc; nos notifique que n&atilde;o deseja mais receber essas
                    informa&ccedil;&otilde;es.
                </p>

                <p>&nbsp;</p>

                <h2 className="text-xl font-semibold mb-2">5 - Quais s&atilde;o os seus direitos?</h2>

                <p>
                    Se voc&ecirc; acredita que qualquer dado pessoal que guardamos sobre voc&ecirc; est&aacute; incorreto ou incompleto,
                    voc&ecirc; tem o direito de confirmar a situa&ccedil;&atilde;o atual, corrigi-los ou t&ecirc;-los exclu&iacute;dos. Caso
                    voc&ecirc; deseje exercer os diretos acima ou obter algum esclarecimento sobre como tratamos seus dados pessoais, entre
                    em contato com a nossa encarregada, Daiane Salvetti, atrav&eacute;s do e-mail&nbsp;dpo@rometal.com.br. Nossa encarregada
                    analisar&aacute; sua solicita&ccedil;&atilde;o e trabalhar&aacute; com voc&ecirc; para resolver o assunto. Caso
                    considerar que seus dados pessoais n&atilde;o foram tratados de acordo com a lei, voc&ecirc; pode realizar contato com a
                    ANPD, registrando uma reclama&ccedil;&atilde;o junto ao site https://www.gov.br/anpd/pt-br.
                </p>

                <p>&nbsp;</p>

                <p>Termos e Condi&ccedil;&otilde;es de uso do Formul&aacute;rio de Contato</p>

                <p>Baseado na LGPD &ndash; Lei 13.709/2018</p>

                <p>&nbsp;</p>

                <p>
                    N&oacute;s da Rometal estamos comprometidos em resguardar sua privacidade. Quando voc&ecirc; preenche um
                    formul&aacute;rio em nosso site, com seu endere&ccedil;o de e-mail por exemplo, utilizaremos essas
                    informa&ccedil;&otilde;es apenas para contato referente a solicita&ccedil;&atilde;o enviada pelo formul&aacute;rio. O
                    usu&aacute;rio deve estar ciente de que, ao fazer seu cadastro atrav&eacute;s de formul&aacute;rios no nosso site,
                    est&aacute; disposto a receber estas correspond&ecirc;ncias eletr&ocirc;nicas, seu descadastramento pode ser feito a
                    qualquer momento.
                </p>

                <p>Caso voc&ecirc; possua alguma d&uacute;vida, o convidamos para ler nosso Aviso de Privacidade, que se encontra acima.</p>

                <p>
                    Voc&ecirc; est&aacute; ciente que ao preencher as informa&ccedil;&otilde;es com seus dados pessoais e de contato
                    solicitados, est&aacute; concordando com o que foi exposto acima.
                </p>
            </div>

            <div className="text-center">
                <button
                    onClick={handleAceitar}
                    disabled={!canAccept || sending}
                    className={`relative px-6 py-2 rounded-md font-medium transition-colors ${
                        canAccept ? 'bg-secondary hover:bg-opacity-80' : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    } ${sending ? 'cursor-wait' : ''}`}
                >
                    <span className={`text-white${sending ? ' text-opacity-0' : ''}`}>Eu Aceito os Termos de Uso</span>
                    {sending && (
                        <div role="status" className="absolute inset-0 flex justify-center items-center">
                            <svg
                                aria-hidden="true"
                                className="w-6 h-6 text-white text-opacity-60 animate-spin fill-white"
                                viewBox="0 0 100 101"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                    fill="currentColor"
                                />
                                <path
                                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                    fill="currentFill"
                                />
                            </svg>
                            <span className="sr-only">Loading...</span>
                        </div>
                    )}
                </button>

                {!canAccept && <p className="text-sm text-red-500 mt-2">Por favor, leia o termo até o final.</p>}
            </div>
        </div>
    );
};

export default TermsModal;
